/**
 * Vanilla textFill — replaces the jquery.textfill jQuery plugin.
 * Resizes the first <span> inside each matched container so it fills the container.
 *
 * @param {string|Element|NodeList} target  CSS selector, DOM element, or NodeList
 * @param {Object} options
 *   maxFontPixels  {number} Maximum font size in px (default 40; <=0 means unconstrained)
 *   minFontPixels  {number} Minimum font size in px (default 4)
 *   innerTag       {string} Tag of the inner text element (default 'span')
 */
function textFill(target, options) {
  var opts = Object.assign({ maxFontPixels: 40, minFontPixels: 4, innerTag: 'span' }, options);

  var containers;
  if (typeof target === 'string') {
    containers = document.querySelectorAll(target);
  } else if (target instanceof Element) {
    containers = [target];
  } else {
    containers = Array.from(target);
  }

  containers.forEach(function(container) {
    var ourText = container.querySelector(opts.innerTag);
    if (!ourText || container.offsetWidth === 0) return;

    var maxHeight = container.offsetHeight;
    var maxWidth = container.offsetWidth;
    var maxFont = opts.maxFontPixels <= 0 ? maxHeight : opts.maxFontPixels;
    var minFont = opts.minFontPixels;

    // Binary search for the largest font that fits
    while (minFont < Math.floor(maxFont) - 1) {
      var mid = Math.floor((minFont + maxFont) / 2);
      ourText.style.fontSize = mid + 'px';
      if (ourText.offsetWidth <= maxWidth && ourText.offsetHeight <= maxHeight) {
        minFont = mid;
      } else {
        maxFont = mid;
      }
    }
    ourText.style.fontSize = minFont + 'px';
  });
}

window.textFill = textFill;
